// * Stacking ladder shared by the sui overlays and the app panels, so a dialog,
// * its backdrop and the app's own layers never argue about order.
export const ZIndex = {
  BEHIND: -1,
  BASE: 1,
  DROPDOWN: 100 /* menus, selects, context menus */,
  POPOVER: 200 /* date pickers, rich panels, custom UI */,
  TOOLTIP: 300 /* info bubbles, non-interactive */,
  STICKY: 400 /* sticky headers, toolbars */,
  OVERLAY: 500 /* backdrop, dialog background */,
  DIALOG: 600 /* base dialogs */,
  FULLSCREEN: 700 /* full-screen panel */,
  HELP: 800 /* help */,
  TOAST: 800 /* notifications */,
  ERRORS: 900 /* Error messages */,
  TOP: 9999 /* emergency only, for debugging */,
} as const;
